module.exports = __webpack_public_path__ + "static/media/hlologo.6600d862.svg";